// Shortcut for providing alternate styles based on a prop name
export const variant = (propKey, variants, fallback = "") => (props) => {
    const variantKey = props[propKey];
    const styleDefinition = variantKey && variants[variantKey];
    if (!(variantKey && styleDefinition)) {
        return fallback;
    }
    // If a css`` template literal is used, return the results
    if (Array.isArray(styleDefinition) || typeof styleDefinition === "string") {
        return styleDefinition;
    }
    if (typeof styleDefinition !== "function") {
        throw new TypeError(`Variant value must a string, function or css template literal! Variant for prop “${propKey}” returned ${typeof styleDefinition}. ${styleDefinition}`);
    }
    return styleDefinition(props);
};
